import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

const btn = document.querySelector('[js-newsletter-btn]')
const pop = document.querySelector('[js-newsletter]')
const close = document.querySelector('[js-newsletter-close]')

let isOpen = false

if (pop && btn) {
  btn.addEventListener('click', () => {
    pop.style.display = 'flex';
    isOpen = true
    disableBodyScroll(document.body)
  })

  close.addEventListener('click', () => {
    pop.style.display = 'none';
    isOpen = false
    enableBodyScroll(document.body)

  })
}